<template>
  <div>
    <div class="main-block">
      <div class="container v-align">
        <div class="row v-align">
          <div class="col col-4 sm-6 offset-1">
            <h1 class="h3">
              {{ $c.text('pages.contact-us.title') }}
            </h1>
            <p class="body-2">
              {{ $c.text('pages.contact-us.subtitle') }}
            </p>
            <div>
              <ButtonArrow
                text="Help Center"
                type="nuxt-link"
                to="/support/"
              />
            </div>
            <div>
              <ButtonArrow
                text="Q&A Hub"
                type="nuxt-link"
                to="/qa-hub/"
              />
            </div>
          </div>
          <div class="offset-1 col-5 sm-6 col img-wrap">
            <img :src="getImg">
          </div>
        </div>
      </div>
    </div>
    <div class="dark-wall">
      <div class="container">
        <div class="row">
          <div class="offset-1 col-5 col contact-form-container">
            <div class="form">
              <h2 class="h4">
                Send Us a Message!
              </h2>
              <form
                id="aboutUs" method="post"
                @submit="handleContactFormSubmit"
              >
                <div class="col-12">
                  <div>
                    <label class="required">Full Name</label>
                    <input v-model="name" type="text" placeholder="Enter your name">
                  </div>
                </div>
                <div class="col-12">
                  <div>
                    <label class="required">Email</label>
                    <input v-model="email" type="email" placeholder="Enter your email">
                  </div>
                </div>
                <div class="col-12">
                  <label class="required">Message</label>
                  <textarea
                    v-model="message" cols="40" rows="5"
                    placeholder="Your message"
                  />
                </div>
                <div class="row">
                  <div class="offset-1 col-10 col">
                    <button type="submit" :disabled="!email || !name || !message" class="col-12 btn-primary bnt-lg">
                      Send Message
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="offset-1 col-4 col contact-information">
            <div class="col-12">
              <h2 class="h3">
                Contact Information
              </h2>
              <p class="body-2">
                {{ $c.text('pages.contact-us.contactInfo') }}
              </p>
              <p class="links">
                <nuxt-link to="/support/">
                  Help Center
                </nuxt-link>
                <nuxt-link to="/qa-hub/">
                  Q&A Hub
                </nuxt-link>
              </p>
              <p class="contacts">
                <span class="v-align">
                  <EnvelopeIcon class="envelope" />
                  <a v-if="$config.platform === 'ds'" href="mailto:team@365datascience.com">team@365datascience.com</a>
                  <a v-else href="mailto:team@365financialanalyst.com">team@365financialanalyst.com</a>
                </span>
                <span><PinIcon class="pin" />19 Vitosha Street, <br>Sofia, Bulgaria <br>1000</span>
              </p>

              <SocialIcons class="col-8" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import ButtonArrow from '@itbpbg/lms-components/src/components/ButtonArrow';
import PinIcon from '../assets/svg/pin.svg?vue-component';
import EnvelopeIcon from '../assets/svg/envelope.svg?vue-component';
import SocialIcons from '../components/SocialIcons';

export default {
  components: {
    ButtonArrow,
    EnvelopeIcon,
    PinIcon,
    SocialIcons,
  },
  mixins: [global],
  async asyncData({ $axios, route, $config }) {
    const page = await $axios.$get(`/pages/${route.fullPath}`).catch(() => {});
    page.fullPath = `${$config.siteUrl}${route.fullPath}`;
    page.metaFullImageUrl = `${$config.siteUrl}/resources/${page.metaImage}`;

    page.created = page.created || new Date();
    page.updated = page.updated || new Date();
    return { page };
  },
  data: () => ({
    name: '', email: '', message: '',
  }),
  head() {
    const linkedData = this.$linkedDataLoad([
      { key: 'Organization' },
      { key: 'WebSite' },
      { key: 'WebPage', values: this.page },
    ]);

    return {
      titleTemplate: `${this.page.metaTitle}%s`,
      link: [
        { rel: 'canonical', href: this.canonicalURL() },
      ],
      meta: this.metaProps(this.page),
      script: [linkedData],
    };
  },
  computed: {
    getImg() {
      if (this.$config.platform === 'fa') {
        return require('../assets/images/fa/fa-contacts.jpg');
      }
      return require('../assets/images/contacts.png');
    },
  },
  methods: {
    async handleContactFormSubmit(e) {
      e.preventDefault();
      const {
        name, email, subject, message,
      } = this;

      try {
        await this.$axios.$post('/feedback/get-in-touch', {
          name, email, subject, message,
        });

        await this.$store.dispatch('modals/open', {
          name: 'default',
          message: 'Thank you for your message. It has been sent.',
        });
        dataLayer.push({ event: 'ContactForm' });
        this.name = '';
        this.email = '';
        this.subject = '';
        this.message = '';
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.v-align {
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.main-block {
  background: var(--gradient-brand-1);
  background-color: var(--main-dark);
  color: var(--main-light);
  padding-top: var(--spacing-80);
  padding-bottom: var(--spacing-90);

  .container {
    min-height: 380px;
    padding-top: var(--spacing-90);

    .col-4 {
      padding-top: 20px;
    }

    h1 {
      margin-top: 0;
      margin-bottom: var(--spacing-16);
    }

    p {
      color: var(--main-light-shade-4);
      margin-top: 0;
      margin-bottom: var(--spacing-48);
    }

    a {
      color: var(--accent);
      display: inline-flex;
      font-size: 18px;
      line-height: 1;

      &:first-of-type {
        margin-bottom: var(--spacing-26);
      }
    }

    .img-wrap {
      align-items: center;
      display: flex;
      height: auto;

      img {
        max-width: 100%;
        border-radius: 12px;
      }
    }
  }

  @include bp($bp-phone) {
    display: none;

    .container {
      img {
        width: 100%;
        padding-top: calc(var(--spacing-60) / 2);
        padding-left: 0;
      }
    }
  }
}

.dark-wall {
  background-color: var(--main-dark-light-1);
  padding: var(--spacing-100) 0 var(--spacing-120);
  overflow: hidden;

  .contact-form-container {
    .form {
      background-color: var(--main-light-shade-1);
      border-radius: 10px;
      box-shadow: 0 0 60px rgba(0, 14, 36, 0.4);
      padding: var(--spacing-48) var(--spacing-48) var(--spacing-24);

      .h4 {
        margin: 0;
      }

      form {
        padding: var(--spacing-48) 0 0;

        > div {
          margin-bottom: var(--spacing-24);
        }

        label {
          display: block;
          font-size: 14px;
          margin-bottom: var(--spacing-6);
          line-height: 17px;
        }

        input,
        textarea {
          background-color: var(--main-light-shade-1);
        }

        textarea {
          height: auto;
        }

        button {
          margin: var(--spacing-24) auto var(--spacing-12);
          width: 100%;
          height: 58px;
        }
      }
    }
  }

  .contact-information {
    color: var(--main-light);

    .links {
      display: none;
      color: var(--accent);
      font-size: 18px;
      font-weight: 600;

      a:first-of-type {
        margin-right: var(--spacing-36);
      }
    }

    > div {
      padding-top: var(--spacing-48);

      h2 {
        margin-top: 0;
        margin-bottom: var(--spacing-16);
      }

      .body-2 {
        color: var(--main-light-shade-4);
        margin-bottom: var(--spacing-48);
      }

      .contacts {
        margin-top: 0;
        margin-bottom: var(--spacing-60);

        > span {
          line-height: 24px;
          margin-bottom: var(--spacing-16);

          span,
          a {
            color: var(--main-light);
            display: block;
            margin: var(--spacing-4) 0;
          }
        }
      }

      span {
        align-content: space-evenly;
        display: flex;

        svg {
          vertical-align: middle;
          margin-right: var(--spacing-16);
        }
      }
    }
  }

  @include bp($bp-phone) {
    padding-bottom: 0;

    .container {
      padding-left: 0;
      padding-right: 0;
    }

    .contact-information {
      padding: var(--spacing-80) 0;

      .links {
        display: inline-flex;
        margin-bottom: var(--spacing-60);
        flex-direction: row-reverse;

        a {
          margin-right: 36px;
        }
      }

      > div {
        padding-left: var(--spacing-36);
        padding-right: var(--spacing-36);
      }
    }

    .contact-form-container {
      background-color: var(--main-light);
      order: 2;

      .form {
        box-shadow: none;
        padding: var(--spacing-80) var(--spacing-24);
        overflow: hidden;

        form {
          > div:last-child {
            margin-bottom: 0;
          }

          button {
            margin-bottom: 0;
          }
        }
      }

      .form .h4 {
        font-size: 24px;
      }
    }
  }
}

@include bp($bp-phone) {
  .fa {
    .dark-wall {
      padding-top: var(--spacing-120);
      background: linear-gradient(179.58deg, rgba(3, 111, 253, 0.14) -0.05%, rgba(3, 111, 253, 0.05) 25.66%, rgba(1, 22, 51, 0) 99.77%), var(--main-dark);

      .contact-information {
        padding-top: 0;

        > div span .envelope path:last-of-type[stroke] {
          stroke: var(--accent-light-2-200);
        }

        > div span .pin path:first-of-type[stroke] {
          stroke: var(--accent-light-2-200);
        }

        > div .body-2 {
          margin-bottom: var(--spacing-24);
        }

        .links {
          margin-top: 0;
        }
      }
    }
  }
}
</style>
